// @flow 
import { Capacitor } from "@capacitor/core";
import { ScreenOrientation, OrientationType } from '@capawesome/capacitor-screen-orientation';
import { useEffect } from "react";

type Props = {};

const PortraitLock = (props: Props) => {
	
	useEffect(() => {
		if (Capacitor.isNativePlatform()) {
			ScreenOrientation.lock({ type: OrientationType.PORTRAIT });
		}
	}, []);
	
	return null;
};

export default PortraitLock